import React, { Component } from "react"
import { singleMeritalStatus, femaleMale, socialSection } from "../../variables/ComboValues";
import { updateElement } from "../Tree/Utils.js"
import { box_element } from './ParentEmployment'


export const  ParentInfo_microLegend = {
    "parent_family_name": "שם משפחה",
    "parent_first_name": "שם פרטי",
    "parent_gender": "מין",
    "parent_idnum": "ת. זהות",
    "parent_phone1": "טלפון",
    "parent_email": "אימייל",
    "parent_birth_date": "ת. לידה",
    "parent_birth_country": "ארץ לידה",
    "parent_immigration_year": "ת. עליה",
      "parent_social_section": "אורח חיים",
      "parent_health": "מצב בריאותי",
      "parent_bituachleumi": "אי כושר עבודה או אי כושר השתכרות בבט''ל?",
      "parent_bituachleumi_temp": "הכרה זמנית/קבועה",
      "parent_kupat_holim": "קופת חולים",
    "parent_merital_status": "סטטוס",
    "parent_married_number": "סבב נישואין",
    "parent_family": "קוד משפחה",
    "parent_partner": "קוד בן זוג",
    "parent_kids": "ילדים"
}

export class ParentGeneral extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      // this.onSaveTable = this.onSaveTable.bind(this)
     // this.handleProductTable = this.handleProductTable.bind(this)
    }
    handleProductTableDate = (day, key)  => {
      var newp = Object.assign(this.state.products)
      newp[key] = day
      this.setState({products:newp})
    }

    handleProductTable = (evt) => {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable = (evt) => {
      evt.preventDefault()
      const { save2DB, subTableId, memberPostId } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(memberPostId, this.state.products, subTableId, "group" )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} 
            products={this.state.products} 
            onProductTableDate={this.handleProductTableDate}
          />
      )
    }
  }
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable, onProductTableDate } = this.props
      if (typeof products === "undefined")
        return (<h1>בטעינה</h1>)
      // console.log("General - products", products)
      
          const product = products
          if (typeof product.id === "undefined"){
            product.id=1
            //console.log("paRENTMGR product ID is undefined")
          }
          const cellData=[{
            type: "text",
            name: "parent_family_name",
            value: product.parent_family_name,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "text",
            name: "parent_first_name",
            value: product.parent_first_name,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "select",
            options: femaleMale, // ["נקבה","זכר"],
            name: "parent_gender",
            value: product.parent_gender,
            id: product.id,
            style: {width: "60px"},
            edit: true
          },{
            type: "text",
            name: "parent_idnum",
            value: product.parent_idnum,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "date",
            name: "parent_birth_date",
            value: product.parent_birth_date === null ? "" : product.parent_birth_date,
            id: product.id,
            style: {width: "90px"},
            placeholder: 'dd/mm/yyyy',
            edit: true
          },{
            type: "text",
            name: "parent_birth_country",
            value: product.parent_birth_country,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "date",
            name: "parent_immigration_year",
            value: product.parent_immigration_year,
            id: product.id,
            style: {width: "90px"},
            placeholder: 'dd/mm/yyyy',
            edit: true
          },{
            newsection: "יצירת קשר",
            type: "text",
            name: "parent_phone1",
            value: product.parent_phone1,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "text",
            name: "parent_email",
            value: product.parent_email,
            id: product.id,
            style: {width: "180px"},
            edit: true
          },
          {
            newsection:"סטטוס",
            type: "select",
            options: singleMeritalStatus, // ["רווק/ה","נשואים","חיים יחד","פרוד/ה","גרוש/ה","פרוד/ה","אלמנ/ה","מסורבת גט","עגונה","אחר"],
            name: "parent_merital_status",
            value: product.parent_merital_status,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "text",
            name: "parent_married_number",
            value: product.parent_married_number,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },
      {
        type: "select",
        options: socialSection, // ["חילוני","מסורתי","דתי","חרדי","אחר"],
        name: "parent_social_section",
        value: product.parent_social_section,
        id: product.id,
        style: {width: "90px"},
        edit: true
      }] 
          
      return (box_element(tableTitle, onSaveTable, onProductTableUpdate, product, cellData, ParentInfo_microLegend, onProductTableDate ))

    }
  }